// extracted by mini-css-extract-plugin
export var dropdown = "_su-0";
export var imageWrapper = "_su-3";
export var itemNameContainer = "_su-1";
export var productImage = "_su-2";
export var spinnerWrapper = "_su-4";